import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import Login from "./Login";

console.log(tmtLogin);

createRoot(document.getElementById("tmt-event-login")).render(
  <StrictMode>
    <Login />
  </StrictMode>
);
